<template>
  <div class="new">
    <ToolTitle :title="company.name" :menu="true" :menuby="'company'" />
    <div class="new__form">
      <FormInput :placeholder="'Form adı:'" :required="true" v-model.trim="form.name" />
      <FormButton @action="create()" :text="'Form oluştur'" :status="status" />
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
export default {
  data() {
    return {
      company: this.$store.getters.getActiveCompany,
      form: {},
      status: {
        loading: false,
        message: "",
        type: ""
      }
    };
  },
  methods: {
    create: async function() {
      let vm = this;

      if (!vm.form.name) return;

      vm.form.created = vm.$store.getters.getUser;
      vm.form.company = vm.$store.getters.getActiveCompany;

      vm.status.loading = true;
      vm.status.type = "";

      await API.createForm(vm.form)
        .then(response => {
          vm.status.type = "Success";
          if (response.status.code != 200) vm.status.type = "Error";
          vm.status.message = response.status.message;

          if (response.status.code != 200) return;
          // this.$router.push({
          //   name: "form",
          //   params: {
          //     form: response.result.path,
          //     company: vm.form.company.path
          //   }
          // });
        })
        .catch(error => {
          vm.status.type = "Error";
          vm.status.message = error;
        });

      vm.form = {};
      vm.status.loading = false;
    }
  }
};
</script>